// eslint-disable-next-line import/no-anonymous-default-export
export default [
    {
       id: 1,
       url: "https://nsm09.casimages.com/img/2021/03/18//21031810380517254117321773.jpg",
       title: 'Coffret de noël',
       text: [
            "1 huile essentielle 100ml",
            "1 bougie parfumée",
            "1 crème de nuit",
        ],
       alt: "décoration au thème de noël avec des cadeaux et une petite lanterne",
    },
    {
        id: 2,
        url: "https://nsm09.casimages.com/img/2021/03/18//21031810380517254117321772.jpg",
        title: 'Coffret de la Saint-Valentin',
        text: [
            "Pour lui: 1 fluide anti-âge tonifiant",
            "Pour elle: 2 crêmes jour et nuit",
            "Pour les deux: 1 huile de massage",
            ],         
        alt: "deux ballons en forme de coeur chacun tenu par un homme et une femme",
     },
     {
        id: 3,
        url: "https://nsm09.casimages.com/img/2021/03/18//21031810380517254117321774.jpg",
        title: 'Coffret Energie',
        text: [
            "1 bon pour massage tonifiant",
            "1 huile essentielle 100ml",
            "1 crème de jour",
        ],
        alt: "visage d'une femme sur fond sombre avec des flux d'énergie lui traversant le visage",
     },
     {
        id: 4,
        url: "https://nsm09.casimages.com/img/2021/03/18//21031810380617254117321776.jpg",
        title: 'Coffret Détente',
        text: [
            "1 bon pour soin du visage complet",
            "1 bon pour soin du corps complet",
            "1 bon pour massage relaxant",
            "1 crème + 1 huile essentielle",
        ],
        alt: "décoration de petits flacons, des encens et des fleurs",
     }
]